// extracted by mini-css-extract-plugin
export default {"title_box":"style_title_box__x84rF","title":"style_title__yP5US","cc":"style_cc__kRtf1","wave_canvas":"style_wave_canvas__J+6op","opacity":"style_opacity__l0y1H"};